export const SET_INTEGRATIONS = 'DATA_INTEGRATIONS/SET_INTEGRATIONS'
export const SET_INTEGRATION = 'DATA_INTEGRATIONS/SET_INTEGRATION'
export const SET_PROVIDERS = 'DATA_INTEGRATIONS/SET_PROVIDERS'
export const SET_AVAILABLE_FIELDS = 'DATA_INTEGRATIONS/SET_AVAILABLE_FIELDS'
export const SET_SYNC_LOGS = 'DATA_INTEGRATIONS/SET_SYNC_LOGS'
